"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpExecutor = void 0;
const tslib_1 = require("tslib");
const axios_1 = tslib_1.__importDefault(require("axios"));
const unexpected_client_error_1 = require("../errors/unexpected.client.error");
const client_error_1 = require("../errors/client.error");
const timezone_transform_payload_1 = require("../clients/utils/timezone-transform-payload");
const settings_1 = require("../settings");
const executor_base_1 = require("./executor.base");
class HttpExecutor extends executor_base_1.BaseExecutor {
    constructor(settings = settings_1.DefaultClientSettings) {
        super();
        this.settings = settings;
    }
    executeRaw(method, path, data, opts) {
        var _a;
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const axiosOpts = opts || {};
            const axiosResponse = yield this.executeCall(method, path, data, Object.assign(Object.assign({}, axiosOpts), { responseType: 'arraybuffer' }));
            if (axiosResponse.status > 299) {
                let responseData;
                try {
                    const decoder = new TextDecoder('utf8');
                    responseData = JSON.parse(decoder.decode(axiosResponse.data));
                }
                catch (e) {
                    (_a = this.settings.logger) === null || _a === void 0 ? void 0 : _a.error(`Error converting buffer to JSON ${e.message}`);
                }
                throw new client_error_1.ClientError({
                    success: false,
                    errorMessage: (responseData === null || responseData === void 0 ? void 0 : responseData.errorMessage) || 'Binary response error',
                    errorCode: (responseData === null || responseData === void 0 ? void 0 : responseData.errorCode) || 'UNKNOWN_ERROR',
                });
            }
            return axiosResponse;
        });
    }
    executeCall(method, path, data, opts = {}) {
        var _a, _b, _c, _d;
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const headers = Object.assign(this.getDefaultHeaders(!!data), opts === null || opts === void 0 ? void 0 : opts.headers);
            const timeout = 30000;
            if (this.formatDateWithTimezone && data) {
                data = (0, timezone_transform_payload_1.timezoneTransformPayload)(data);
            }
            const config = this.settings;
            if (!config.url) {
                throw new Error('Gateway URL not available.');
            }
            const url = config.url + path;
            (_a = config.logger) === null || _a === void 0 ? void 0 : _a.log(`${method.toUpperCase()} ${url} ${JSON.stringify(data)}`);
            const requestConfig = Object.assign(Object.assign({}, opts), { method,
                url,
                data,
                headers,
                timeout, validateStatus: () => true });
            config.onRequest && config.onRequest(requestConfig);
            const responsePromise = axios_1.default.request(requestConfig);
            let axiosResponse;
            try {
                axiosResponse = yield responsePromise;
                config.onResponse && config.onResponse(axiosResponse);
                if (opts.responseCookies) {
                    const setCookie = require('set-cookie-parser');
                    const cookies = setCookie.parse(axiosResponse);
                    for (const cookie of cookies) {
                        opts.responseCookies.set(cookie.name, cookie);
                    }
                }
            }
            catch (e) {
                (_b = config.logger) === null || _b === void 0 ? void 0 : _b.error(`${method.toUpperCase()} ${url}`);
                (_c = config.logger) === null || _c === void 0 ? void 0 : _c.error(e);
                throw new unexpected_client_error_1.UnexpectedClientError(e.message);
            }
            const contentType = axiosResponse.headers['content-type'] || '';
            if (!contentType.includes('application/json') ||
                (contentType.includes('application/json') && opts.responseType === 'arraybuffer')) {
                return axiosResponse;
            }
            if (axiosResponse.status === 404 && opts.returnNullOn404) {
                return { success: true };
            }
            const response = axiosResponse.data;
            response.headers = axiosResponse.headers;
            if (!response.success) {
                (_d = config.logger) === null || _d === void 0 ? void 0 : _d.error(`${method.toUpperCase()} ${url}`, JSON.stringify(response));
                if (opts.throwOnError == null || opts.throwOnError) {
                    throw new client_error_1.ClientError(response);
                }
                return response;
            }
            return response;
        });
    }
    getDefaultHeaders(withBody) {
        const headers = this.settings.getHeaders ? this.settings.getHeaders() : {};
        return Object.assign(Object.assign({}, headers), (withBody && { 'content-type': 'application/json' }));
    }
}
exports.HttpExecutor = HttpExecutor;
//# sourceMappingURL=http-executor.js.map